import { request } from "./request";
import { routes } from '../router/routes';


export const getFilterOptions = (params) => {
    return request({
        method: 'post',
        url: '/mapping-select-options/getFilterOptions',
        params
    })
}


export const checkImageBase = (src) => {
    if (!src) return src;
    const IMG_UPLOAD_BASE = process.env.REACT_APP_BASE_UPLOAD_PATH;
    if (src.indexOf('http') === -1 && src.indexOf('https') === -1) return IMG_UPLOAD_BASE + src;
    return src;
}
export const checkListImageBase = res => {
    res.list = completionListImageBase(res.list)
    return res;
}

// 用於檢查object中photo數組內的src是否帶了http，沒的話則帶上oss的地址
export const checkImageBaseByPhotoArray = obj => {
    if (obj?.photo?.filter(tem => tem.photoUrl).length) {
        obj.photo = obj.photo.map(photo => {
            photo.photoUrl = checkImageBase(photo.photoUrl);
            photo.thumbnailUrl = checkImageBase(photo.thumbnailUrl);
            return photo
        })
    }

    return obj;
}
// 用戶檢查array內的object，內容checkImageBaseByPhotoArray
export const checkListImageBaseByPhotoArray = arr => {
    return arr.map(checkImageBaseByPhotoArray);
}

export const completionListImageBase = list => {
    list.forEach(item => {
        item.fileUrl && (item.fileUrl = checkImageBase(item.fileUrl));
        item.photoUrl && (item.photoUrl = checkImageBase(item.photoUrl));
        item.thumbnailUrl && (item.thumbnailUrl = checkImageBase(item.thumbnailUrl));
    })
    return list;
}

/**
 * 截取文件全局变量前缀方法
 * @param url
 * @author: luguojin
 * @returns {string}
 */
export const InterceptPrefix = (url) => {
    if (!url) return;
    const IMG_UPLOAD_BASE = process.env.REACT_APP_BASE_UPLOAD_PATH;
    var reg = new RegExp(IMG_UPLOAD_BASE)
    return url.indexOf(IMG_UPLOAD_BASE) === -1 ? url : url.replace(reg, '');
}

/**
 * 截取文件全局变量前缀方法
 * @param list
 * @author: luguojin
 * @returns {string}
 */
export const InterceptListPrefix = (list) => {
    if (!list || list.length === 0) return;
    list.forEach(item => {
        item.photoUrl && (item.photoUrl = InterceptPrefix(item.photoUrl));
        item.fileUrl && (item.fileUrl = InterceptPrefix(item.fileUrl));
        item.thumbnailUrl && (item.thumbnailUrl = InterceptPrefix(item.thumbnailUrl));
    });
    return list;
}

export const checkHasRouter = (checkpath) => {
    let find = false;
    // const RouteMenuData = RouteMenu();
    // let routes = routes();
    const splitPath = checkpath.split('/');
    let helpher = routelist => {
        if (!find) {
            routelist.map(item => {
                if (checkpath === item.path) {
                    // path全等，則放行
                    find = true;
                } else if (item.path.indexOf(':') >= 0) {
                    // 不全等，得看看是不是動態路由,是的話，就拆分逐一匹配
                    const itemPathSplit = item.path.split('/');
                    if (splitPath.length === itemPathSplit.length) {
                        let checkSuccess = true;
                        for (let i = 0; i < itemPathSplit.length; i++) {
                            let pi = itemPathSplit[i];
                            let si = splitPath[i];
                            if (pi.indexOf(':') < 0 && pi !== si) {
                                checkSuccess = false;
                                break;
                            }
                        }
                        if (checkSuccess) {
                            // console.log('匹配成功', item.path, checkpath)
                            find = true;
                        }
                    }

                }
                item.routes?.length && helpher(item.routes)
            })
        }
    }
    helpher(routes);
    console.log('find', find, checkpath, routes)
    return find
}